import React from "react";
import styled from "styled-components";

export const PageInner = styled.div`
    max-width: 350px;
    margin: 0 auto;
    ${props => props.css}
`;
